export enum MapCorrelationsCurrency {
	RUB = "RUB",
	USD = "USD"
}

export enum MapCorrelationsMode {
	CORRELATION = "CORRELATION",
	SIMILARITY = "SIMILARITY"
}

export interface MapCorrelationSettings {
	currency: MapCorrelationsCurrency;
	mode: MapCorrelationsMode;
}